"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSilentAudioTrack = createSilentAudioTrack;
/**
 * Creates our constant source of audio, returns the audioBufferSourceNode which is playing on repeat.
 */
function createConstantSource(audioCtx) {
    // Create our buffer source node
    const constantSourceNode = audioCtx.createBufferSource();
    const constantBuffer = audioCtx.createBuffer(1, 1, audioCtx.sampleRate);
    const bufferData = constantBuffer.getChannelData(0);
    for (let i = 0; i < bufferData.length; i++) {
        // Then filling that channel with white noise
        bufferData[i] = Math.random() * 2 - 1;
    }
    constantSourceNode.buffer = constantBuffer;
    // Loop the audio so that it will keep replaying
    constantSourceNode.loop = true;
    return constantSourceNode;
}
function createSilentAudioTrack(audioCtx) {
    const source = createConstantSource(audioCtx);
    const gainNode = audioCtx.createGain();
    // Set the audio of the gain node to almost nothing
    gainNode.gain.value = 0.001;
    source.connect(gainNode);
    // Connect our gainNode to the final destination of all of the audio in the context.
    gainNode.connect(audioCtx.destination);
    source.start();
    const audioDestinationMediaStream = audioCtx.createMediaStreamDestination();
    return audioDestinationMediaStream.stream.getAudioTracks()[0];
}
//# sourceMappingURL=index.js.map